import { SVGProps } from 'react'

export const RollbackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_2606_23407)">
      <path
        d="M4.99935 5.00008L6.66602 3.33341M6.66602 3.33341L4.99935 1.66675M6.66602 3.33341H4.99935C3.1584 3.33341 1.66602 4.8258 1.66602 6.66675M14.9993 15.0001L13.3327 16.6667M13.3327 16.6667L14.9993 18.3334M13.3327 16.6667H14.9993C16.8403 16.6667 18.3327 15.1744 18.3327 13.3334M8.4902 5.41675C9.04526 3.26021 11.0029 1.66675 13.3327 1.66675C16.0941 1.66675 18.3327 3.90532 18.3327 6.66675C18.3327 8.99653 16.7392 10.9541 14.5827 11.5092M11.666 13.3334C11.666 16.0948 9.42744 18.3334 6.66602 18.3334C3.90459 18.3334 1.66602 16.0948 1.66602 13.3334C1.66602 10.572 3.90459 8.33342 6.66602 8.33342C9.42744 8.33342 11.666 10.572 11.666 13.3334Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2606_23407">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
